import { useEffect, useState } from 'react';

import { ViewTypes } from '../../tokens';

export const useDeviceType = () => {
  const [device, setDevice] = useState<ViewTypes>();

  useEffect(() => {
    const userAgentString = navigator.userAgent;
    const matchMobile = userAgentString.match(
      /Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i
    );
    const matchTablet = userAgentString.match(/Tablet|iPad/i);

    if (matchMobile && !matchTablet) {
      setDevice(ViewTypes.MOBILE);
    } else if (matchTablet || matchMobile) {
      setDevice(ViewTypes.TABLET);
    } else {
      setDevice(ViewTypes.DESKTOP);
    }
  }, []);

  return device;
};
